import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Spinner,
} from "reactstrap";

const API_BASE = process.env.REACT_APP_API_URL || "/api";
const speciesUrl = (name) => encodeURIComponent(name);

const SpeciesCard = ({ species }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSpeciesData = async () => {
      try {
        const res = await fetch(`${API_BASE}/detections/speciesinfo?species=${encodeURIComponent(species)}`);
        const json = await res.json();
        setData(json);
      } catch (err) {
        console.error("Failed to load species info:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    if (species) fetchSpeciesData();
  }, [species]);

  if (loading) return <Spinner color="primary" />;
  if (!data) return <p>Error loading data for species: {species}</p>;

  const wikiUrl = `https://en.wikipedia.org/wiki/${species.replace(/\s/g, "_")}`;
  const allAboutBirdsUrl = `https://www.allaboutbirds.org/guide/${species.replace(/\s/g, "_")}`;

  return (
    <Card className="shadow" style={{ paddingBottom: "0.5rem" }}>
      <CardHeader className="pb-1">
        <Row className="align-items-center">
          <Col xs="8">
            <CardTitle tag="h4" className="mb-1">
              <a href={`/admin/species/${speciesUrl(data.common)}`}>{data.common}</a>
            </CardTitle>
            <div className="text-muted" style={{ fontStyle: "italic", fontSize: "0.95rem" }}>
              {data.scientific}
            </div>
          </Col>
          <Col xs="4" className="text-right">
            <a href={wikiUrl} target="_blank" rel="noopener noreferrer" className="ml-2">
              <i className="fab fa-wikipedia-w text-muted"></i>
            </a>
            <a href={allAboutBirdsUrl} target="_blank" rel="noopener noreferrer" className="ml-3">
              <i className="fas fa-binoculars text-muted"></i>
            </a>
          </Col>
        </Row>
      </CardHeader>
      <CardBody className="pt-1 pb-2">
        <Row>
          <Col xs="4">
            <small className="text-muted">Detections Today</small><br />
            <strong>{data.count_today}</strong>
          </Col>
          <Col xs="4">
            <small className="text-muted">All-Time Detections</small><br />
            <strong>{data.count_total}</strong>
          </Col>
          <Col xs="4">
            <small className="text-muted">Most Recent Detection</small><br />
            <strong>{data.last_detection || "--"}</strong>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default SpeciesCard;
